import { borderLeft, borderRight } from '@mui/system';
import palette from 'theme/palette';
import { ROW_HEIGHT_DEFAULT, ROW_HEIGHT_TEXTTYPE } from './constants';

export const tableStyles = {
  container: (isMobile: boolean, isIOS: boolean = false) => ({
    overflowY: 'auto' as const,
    overflowX: isMobile ? "scroll" : "auto" as "auto" | "scroll" | "visible" | "hidden",
    WebkitOverflowScrolling: 'touch' as const,
    position: 'relative' as const,
    maxWidth: '100%',
    height: '100%',
    marginBottom: '80px',
    touchAction: 'pan-x pan-y' as const,
    WebkitTouchCallout: 'none' as const,
    userSelect: 'none' as const,
    ...(isIOS ? {
      overscrollBehavior: 'none' as const,
      overscrollBehaviorX: 'none' as const,
      overscrollBehaviorY: 'none' as const,
    } : {}),
  }),
  tableWrapper: {
    position: 'relative' as const,
    minWidth: 'max-content',
    width: 'fit-content',
    touchAction: 'pan-x pan-y' as const,
  },
  // Frozen top block: the date header row + the อายุกุ้ง (shrimp-age) row are
  // wrapped together here so both stay pinned when scrolling down (NK-206).
  // The block owns the sticky positioning and stacking; the two rows inside it
  // are in normal flow so they stack with no offset math (which would be
  // fragile under the WebView zoom/transform wrapper).
  // zIndex must beat the virtualized data rows (VirtualRow uses zIndex 10 for
  // non-group rows); at an equal zIndex those later-in-DOM rows paint over the
  // frozen block when scrolling.
  stickyHeaderBlock: {
    position: 'sticky' as const,
    top: 0,
    zIndex: 20,
    minWidth: 'max-content',
    width: 'fit-content' as const,
  },
  headerRow: {
    display: 'flex' as const,
    backgroundColor: palette.light.grey[200],
    minWidth: 'max-content',
    color: palette.light.grey[600],
    touchAction: 'pan-x pan-y' as const,
    pointerEvents: 'auto' as const,
  },
  row: {
    display: 'flex' as const,
    minWidth: 'max-content',
    willChange: 'transform' as const,
    touchAction: 'pan-x pan-y',
  },
  stickyCol1: {
    position: 'sticky' as const,
    left: 0,
    backgroundColor: palette.light.grey[200],
    zIndex: 5,
    width: '300px',
    minWidth: '300px',
    height: `${ROW_HEIGHT_DEFAULT}px`, // default
    flexShrink: 0,
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    touchAction: 'pan-x pan-y' as const,
    pointerEvents: 'auto' as const,
  },
  stickyCol2: {
    position: 'sticky' as const,
    left: 280,
    backgroundColor: palette.light.grey[200],
    zIndex: 5,
    width: '110px',
    minWidth: '110px',
    height: `${ROW_HEIGHT_DEFAULT}px`, // default
    flexShrink: 0,
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    touchAction: 'pan-x pan-y' as const,
    pointerEvents: 'auto' as const,
  },
  cell: {
    padding: '0',
    textAlign: 'center' as const,
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    width: '150px',
    minWidth: '150px',
    height: `${ROW_HEIGHT_DEFAULT}px`, // default
    flexShrink: 0,
    touchAction: 'pan-x pan-y',
  },
  groupCell: {
    textAlign: 'center' as const,
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    height: `${ROW_HEIGHT_DEFAULT}px`, // default
    flexShrink: 0,
    backgroundColor: palette.light.grey[200],
    borderRight: `1.5px solid ${palette.light.grey[300]}`,
    touchAction: 'pan-x pan-y' as const,
    pointerEvents: 'auto' as const,
  },
  headerCell: {
    padding: '10px 8px',
    textAlign: 'center' as const,
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    width: '150px',
    height: `${ROW_HEIGHT_DEFAULT}px`, // default
    minWidth: '150px',
    flexShrink: 0,
    borderBottom: `1.5px solid ${palette.light.grey[300]}`,
    borderTop: `1.5px solid ${palette.light.grey[300]}`,
    borderRight: `1.5px solid ${palette.light.grey[300]}`,
    touchAction: 'pan-x pan-y' as const,
    pointerEvents: 'auto' as const,
  },
  textType: {
    minHeight: `${ROW_HEIGHT_TEXTTYPE}px`,
    maxHeight: `${ROW_HEIGHT_TEXTTYPE}px`,
    height: `${ROW_HEIGHT_TEXTTYPE}px`,
  }
};
